import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-client-page',
  standalone: true,
  imports: [],
  templateUrl: './edit-client-page.component.html',
  styleUrl: './edit-client-page.component.scss'
})
export class EditClientPageComponent {}
